module.exports = __webpack_public_path__ + "img/ds-14.c4fe8a1d.gif";